export default [
    {
        // [0]
        key: "empleado",
        label: "Empleado",
        visible: true,
    },
    {
        // [1]
        key: "fecha",
        label: "Fecha",
        visible: true,
        thClass: "text-center",
        tdClass: "text-center",
    },
    {
        // [2]
        key: "estado",
        label: "Estado",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [3]
        key: "descripcion",
        label: "Descripción",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "archivo",
        label: "Archivo",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [5]
        key: "created_at",
        label: "Fecha de Creación",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [5]
        key: "revisador",
        label: "Aprobado por",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [6]
        key: "remunerable",
        label: "Remunerable",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [7]
        key: "actions",
        label: "Acciones",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
]